import Http from '../../common/services/Http';
import { DashboardSearchCriteria } from './criterias/DashboardSearchCriteria';
import { ConsumesDashboardDto } from './dtos/ConsumesDashboardDto';
import { CountersDashboardDto } from './dtos/CountersDashboardDto';
import DashboardDto from './dtos/DashboardDto';
import { ExpensesDashboardDto } from './dtos/ExpensesDashboardDto';
import { MonthlyCostDashboardDto } from './dtos/MonthlyCostDashboardDto';
import { MonthlyRoutesDashboardDto } from './dtos/MonthlyRouteDashboardDto';
import { NextMaintenancesDashboardDto } from './dtos/NextMaintenancesDashboardDto';
class DashboardService {
	public async get(criteria: DashboardSearchCriteria) {
		const data = await Http.get<DashboardDto>('dashboard', criteria);

		// Fix dates
		if (data) {
			data.consumes?.items.forEach(c => c.items.forEach(cc => (cc.date = new Date(cc.date))));
			data.monthlyCost?.items.forEach(c => c.items.forEach(cc => (cc.date = new Date(cc.date))));
			if (data.monthlyRoute && data.monthlyRoute.items) {
				data.monthlyRoute.items.forEach(cc => (cc.date = new Date(cc.date)));
			}
		}

		return data;
	}

	
	public fixDates(criteria: DashboardSearchCriteria){
		if (criteria.dateFrom) {			
			const year = criteria.dateFrom.getFullYear();
			const month = criteria.dateFrom.getMonth()+1;
			const day = criteria.dateFrom.getDate();
			criteria.dateFrom = new Date(`${year}-${month < 10 ? '0': ''}${month}-${day < 10 ? '0': ''}${day}T00:00:00Z`);			
		}
		if (criteria.dateTo) {
			const year = criteria.dateTo.getFullYear();
			const month = criteria.dateTo.getMonth()+1;
			const day = criteria.dateTo.getDate();
			criteria.dateTo = new Date(`${year}-${month < 10 ? '0': ''}${month}-${day < 10 ? '0': ''}${day}T23:59:59Z`);
		}
		return criteria;
	}

	public async getCounters(criteria: DashboardSearchCriteria) {
		return await Http.get<CountersDashboardDto>('dashboard/counters', this.fixDates(criteria));
	}

	public async getExpenses(criteria: DashboardSearchCriteria) {		
		return await Http.get<ExpensesDashboardDto>('dashboard/expenses', this.fixDates(criteria));
	}

	public async getConsumes(criteria: DashboardSearchCriteria) {
		const data = await Http.get<ConsumesDashboardDto>('dashboard/consumes', this.fixDates(criteria));
		if (data) {
			data.items.forEach(c => c.items.forEach(cc => (cc.date = new Date(cc.date))));
		}
		return data;
	}

	public async getNextMaintenances(criteria: DashboardSearchCriteria) {
		return await Http.get<NextMaintenancesDashboardDto>('dashboard/nextmaintenances', this.fixDates(criteria));
	}

	public async getMonthlyCost(criteria: DashboardSearchCriteria) {
		const data = await Http.get<MonthlyCostDashboardDto>('dashboard/monthlycost', this.fixDates(criteria));
		if (data) {
			data.items.forEach(c => c.items.forEach(cc => (cc.date = new Date(cc.date))));
		}
		return data;
	}

	public async getMonthlyRoutes(criteria: DashboardSearchCriteria) {
		const data = await Http.get<MonthlyRoutesDashboardDto>('dashboard/monthlyroutes', this.fixDates(criteria));
		if (data && data.items) {
			data.items.forEach(cc => (cc.date = new Date(cc.date)));
		}
		return data;
	}


}

export default new DashboardService();
